import { render } from "./package-weight.vue?vue&type=template&id=f23b7f54&ts=true"
import script from "./package-weight.vue?vue&type=script&lang=ts"
export * from "./package-weight.vue?vue&type=script&lang=ts"

import "./package-weight.vue?vue&type=style&index=0&id=f23b7f54&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__